var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-green-900 text-gray-300 text-center py-2 w-full page-text"},[_vm._v(" © 2021 neko2me ")])}
var staticRenderFns = []

export { render, staticRenderFns }